(() => {
  const selector = '[data-bba-infinite-scroll]';
  const initialized = new WeakSet();

  const initialize = (scope = document) => {
    scope.querySelectorAll(selector).forEach((sentinel) => {
      if (initialized.has(sentinel)) return;
      initialized.add(sentinel);

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadNextPage(sentinel, observer);
        },
        { rootMargin: '700px 0px' }
      );

      observer.observe(sentinel);
    });
  };

  const loadNextPage = async (sentinel, observer) => {
    if (sentinel.dataset.loading === 'true' || !sentinel.dataset.nextUrl) return;

    sentinel.dataset.loading = 'true';
    sentinel.classList.add('is-loading');
    const text = sentinel.querySelector('.bba-infinite-scroll__text');
    if (text) text.textContent = sentinel.dataset.loadingText;

    try {
      const response = await fetch(sentinel.dataset.nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incomingItems = page.querySelectorAll('#product-grid > .grid__item');
      const currentGrid = document.querySelector('#product-grid');
      const incomingSentinel = page.querySelector(selector);

      if (!sentinel.isConnected || !currentGrid) return;

      const fragment = document.createDocumentFragment();
      incomingItems.forEach((item) => fragment.append(document.importNode(item, true)));
      currentGrid.append(fragment);

      const nextUrl = incomingSentinel?.dataset.nextUrl || '';
      sentinel.dataset.nextUrl = nextUrl;
      document.dispatchEvent(
        new CustomEvent('bba:collection-products-loaded', {
          detail: { count: incomingItems.length, nextUrl },
        })
      );

      if (!nextUrl) {
        observer.disconnect();
        sentinel.classList.add('is-complete');
        if (text) text.textContent = sentinel.dataset.completeText;
      }
    } catch (error) {
      sentinel.dataset.loading = 'false';
      sentinel.classList.remove('is-loading');
      if (text) text.textContent = sentinel.dataset.errorText;
      return;
    }

    sentinel.dataset.loading = 'false';
    sentinel.classList.remove('is-loading');
  };

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(selector)) initialize(node.parentElement || document);
        else initialize(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
